module.exports = __webpack_public_path__ + "static/img/pdf-ext-thumbnail.e1b36f2a.svg";